export const allowedResponsive =['salesrep','']
// here '' is for the user who is going to reset password without this it was creating issue for IOS responsive